import PropTypes from 'prop-types'
import { useRef, useEffect, useState, useContext } from 'react'
import { useTranslation } from 'next-i18next'
import { useFormContext } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'

// Internal components
import FormError from '../FormError/FormError'
import Svg from '../Svg/Svg'
import { UserContext } from '../../context/UserContext'

const revealClass = ' is-revealed'
const activeClass = ' is-active'

const FormItemOptionlist = (props) => {
  const { item, onFormItemChange, groupedState, revealState } = props

  const { register, setValue, errors } = useFormContext()
  const userContext = useContext(UserContext)

  const [isGrouped, setIsGrouped] = useState(false)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const itemRef = useRef()
  const itemProps = item

  const onChange = (id, value) => {
    setValue(id, value)
    onFormItemChange({ itemProps, itemRef })
  }

  useEffect(() => {
    if (item?.group && groupedState) {
      const itemLabel = item?.group?.label
      const groupedItem = groupedState.filter((str) => {
        return str.label.indexOf(itemLabel) >= 0
      })
      setIsGrouped(groupedItem[0].active)
    }
  }, [groupedState])

  return (
    <div
      ref={itemRef}
      className={`FormItem FormItem--${item.type}${item.modifier ? ` FormItem--${item.modifier}` : ''}${
        revealState ? revealClass : ''
      }${!isGrouped ? '' : activeClass}`}
      data-reveal-target={item.revealed}
    >
      {item.heading && (
        <h3 className="FormItem-optionlistTypeHeading">{!item.vars ? t(item.heading) : t(item.heading, item.vars)}</h3>
      )}
      {item.options.length >= 1 &&
        item.options.map((option, index) => {
          return (
            <label
              className="FormItem-optionlistItem"
              disabled={option.disabled}
              htmlFor={option.name}
              key={`FormItem-optionlistItem--${index + 1}`}
            >
              <input
                type="checkbox"
                id={option.id}
                name={option.id}
                className={`FormItem-input--${item.type}`}
                {...register(option.id)}
                onChange={(e) => onChange(option.id, e?.currentTarget?.checked)}
              />
              <span className="FormItem-optionlistLabel">
                {option.subLabel && <span className="FormItem-optionlistSublabel">{t(option.subLabel)}</span>}
                {option.label}
              </span>
              <Svg modifiers={['FormItem-optionlistIcon']} id="icon-chevron-right" />
            </label>
          )
        })}
      {item.options.length <= 0 && (item.empty || item.translEmpty) && (
        <p>{item.translEmpty ? t(item.translEmpty) : item.empty}</p>
      )}
      <ErrorMessage errors={errors} name={item.name} as={<FormError />} />
    </div>
  )
}

FormItemOptionlist.propTypes = {
  item: PropTypes.object,
  onFormItemChange: PropTypes.func,
  onFormItemLoad: PropTypes.func,
  revealState: PropTypes.any,
  groupedState: PropTypes.any
}

export default FormItemOptionlist
